import { IOneReportResponse } from '@Domains/FinancialStatements';

export const ERROR_MESSAGES = {
  NO_URL_TH:
    'กรุณาจัดทำ และเผยแพร่ แบบแสดงรายการข้อมูลประจำปี / รายงานประจำปี แบบ 56-1 One Report ภาษาไทย',
  NO_URL_EN:
    'คำชี้แจง: กรุณาจัดทำ และเผยแพร่ แบบแสดงรายการข้อมูลประจำปี / รายงานประจำปี แบบ 56-1 One Report ภาษาอังกฤษ (ถ้ามี)',
  CONNECTION_ERROR:
    'ไม่สามารถเชื่อมต่อข้อมูล แบบแสดงรายการข้อมูลประจำปี / รายงานประจำปี แบบ 56-1 One Report ก่อนเผยแพร่แผน Corporate Value Up',
};
const getErrorMessage = (
  oneReportData: IOneReportResponse,
  noUrlMessage: string
): string => {
  if (oneReportData?.url === null) {
    return noUrlMessage;
  }
  return '';
};

export const getErrorMessageRes = (error: unknown) => {
  if (error !== null) {
    return ERROR_MESSAGES.CONNECTION_ERROR;
  }
};

export const getErrorMessageTh = (
  oneReportData: IOneReportResponse
): string => {
  return getErrorMessage(oneReportData, ERROR_MESSAGES.NO_URL_TH);
};

export const getErrorMessageEn = (oneReportData: IOneReportResponse): string =>
  getErrorMessage(oneReportData, ERROR_MESSAGES.NO_URL_EN);
